import { useContext } from 'react';
import { EnterReceiptContext } from 'src/sections/enter_receipt/EnterReceiptContext';

const useEnterReceipts = () => {
  const context = useContext(EnterReceiptContext);
  if (!context)
    throw new Error('Enter Receipts context must be used inside EnterReceiptContextProvider');
  return context;
};

export default useEnterReceipts;
